export default class ImageUtil {
    static srcToImage(src) {
        return new Promise((resolve, reject) => {
            if (!src)
                throw Error('src is empty');
            let url = '';
            if (typeof src === 'string')
                url = src;
            else
                url = URL.createObjectURL(src);
            const image = new Image();
            image.onload = () => {
                URL.revokeObjectURL(url);
                resolve(image);
            };
            image.onerror = () => {
                URL.revokeObjectURL(url);
                // reject(Error());
            };
            image.src = url;
        });
    }
    static drawImage(target, canvas_, sameSize) {
        return new Promise((resolve, reject) => {
            let src = target;
            if (!target)
                throw Error('src is empty');
            if (target instanceof HTMLImageElement)
                src = target.src;
            const img = new Image();
            // 可跨域
            img.setAttribute('crossOrigin', 'anonymous');
            img.onload = () => {
                const canvas = canvas_ || document.createElement('canvas');
                if (!canvas_ || sameSize === true || sameSize === undefined) {
                    canvas.width = img.width;
                    canvas.height = img.height;
                }
                const ctx = canvas.getContext('2d');
                if (!ctx) {
                    reject(Error('getContext failed'));
                    return;
                }
                ctx.drawImage(img, 0, 0);
                resolve({ image: img, context: ctx });
            };
            img.src = src;
        });
    }
    static dowloadImage(target, downloadName) {
        const dowload = (imageDataUrl) => {
            const alink = document.createElement('a');
            alink.download = downloadName || 'default';
            alink.style.display = 'none';
            alink.href = imageDataUrl;
            document.body.appendChild(alink);
            alink.click();
            document.body.removeChild(alink);
        };
        return new Promise((resolve, reject) => {
            if (typeof target === 'string' && target.startsWith('data:image/')) {
                dowload(target);
                resolve(target);
            }
            else {
                ImageUtil.drawImage(target).then((result) => {
                    const { image, context } = result;
                    const url = context.canvas.toDataURL('image/png');
                    dowload(url);
                    resolve(result);
                }).catch(error => {
                    reject(error);
                });
            }
        });
    }
    static clipboardImage(target) {
        return new Promise((resolve, reject) => {
            ImageUtil.drawImage(target).then((result) => {
                const { image, context } = result;
                // @ts-ignore
                if (navigator.clipboard.write) {
                    context.canvas.toBlob((blob) => {
                        if (!blob)
                            throw Error('');
                        // @ts-ignore
                        navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })])
                            .then(() => void resolve(result))
                            .catch((error) => void reject(error));
                    });
                }
                else {
                    // const selection = getSelection();
                    // if (!selection) throw Error('not support');
                    // if (selection.rangeCount > 0) selection.removeAllRanges();
                    // if (!document.queryCommandSupported('copy')) reject(Error('not support'));
                    // image.style.display = 'none';
                    // document.body.appendChild(image);
                    // const range = document.createRange();
                    // range.setStartBefore(image);
                    // range.setEndAfter(image);
                    // range.selectNode(image);
                    // selection.addRange(range);
                    // document.execCommand('copy');
                    // document.body.removeChild(image);
                    // selection.removeAllRanges();
                    // resolve(result);
                }
            }).catch(error => void reject(error));
        });
    }
    static async compositeImage(imageList, canvas) {
        const resultList = [];
        if (imageList.length < 1)
            return;
        for await (const target of imageList) {
            const result = await ImageUtil.drawImage(target, canvas, false);
            resultList.push(result);
        }
        return resultList;
    }
}
